import {createSlice} from '@reduxjs/toolkit';
import {signOut, silentSignIn, signInPopUp, updateUserCredentials} from '../../infrastructure/auth/actions';
import {NormalizedUserResult} from '../../infrastructure/auth/types';
import {
  changeProfilePicture,
  deleteProfilePicture,
  loadUser,
  postProfilePicture,
  setIsNew,
  updateUser,
} from './actions';
import {UserState} from './types';

const initialState: UserState = {
  user: {
    id: '',
    initials: '',
    directoryObjectId: '',
    isNew: false,
    locationProfileType: 'Automatic',
    subscriptionId: '',
    accessProfileType: 'Automatic',
    defaultBuildingId: '',
    email: '',
    firstName: '',
    lastName: '',
    effectiveAccessProfile: '',
    effectiveLocationProfile: '',
    imageHash: undefined,
    parkingLocationProfile: '',
    parkingQuotaProfile: '',
  },
  isUpdatingUser: false,
  isDeletingProfileImage: false,
};

const slice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    function setUserState(state: UserState, {users}: NormalizedUserResult) {
      const user = Object.values(users)[0];
      state.user = user;
    }
    builder
      .addCase(silentSignIn.fulfilled, (state, action) => {
        setUserState(state, action.payload);
      })
      .addCase(signInPopUp.fulfilled, (state, action) => {
        setUserState(state, action.payload);
      })
      .addCase(updateUserCredentials.fulfilled, (state, action) => {
        setUserState(state, action.payload);
      })
      .addCase(updateUser.pending, (state) => {
        state.isUpdatingUser = true;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        setUserState(state, action.payload);
        state.isUpdatingUser = false;
      })
      .addCase(updateUser.rejected, (state) => {
        state.isUpdatingUser = false;
      })
      .addCase(loadUser.fulfilled, (state, action) => {
        setUserState(state, action.payload);
      })
      .addCase(postProfilePicture.fulfilled, (state, action) => {
        state.user.imageHash = action.payload;
      })
      .addCase(changeProfilePicture.fulfilled, (state, action) => {
        state.user.imageHash = action.payload;
      })
      .addCase(deleteProfilePicture.pending, (state) => {
        state.isDeletingProfileImage = true;
      })
      .addCase(deleteProfilePicture.fulfilled, (state) => {
        state.user.imageHash = undefined;
        state.isDeletingProfileImage = false;
      })
      .addCase(deleteProfilePicture.rejected, (state) => {
        state.isDeletingProfileImage = false;
      })
      .addCase(signOut.fulfilled, (state) => {
        state.user = initialState.user;
      })
      .addCase(setIsNew, (state, action) => {
        state.user.isNew = action.payload;
      });
  },
});

export const {reducer: userReducer} = slice;
